import type { TranslationMap } from '../i18n';

export const fr: TranslationMap = {
  // Auth - Common
  'auth.email': 'E-mail',
  'auth.password': 'Mot de passe',
  'auth.firstName': 'Prénom',
  'auth.lastName': 'Nom',
  'auth.back': '← Retour',
  'auth.acceptTerms': "J'accepte les",
  'auth.termsAndConditions': 'Conditions générales',
  'auth.verificationRequired': 'Vérification requise',
  'auth.verificationLinkSent':
    'Veuillez cliquer sur le lien de vérification dans votre boîte de réception.',
  'auth.sending': 'Envoi en cours...',
  'auth.resendLink': 'Renvoyer le lien',
  'auth.phonePlaceholder': '0x xx xx xx xx',

  // Auth - Login
  'auth.signIn': 'Se connecter',
  'auth.signingIn': 'Connexion en cours...',
  'auth.resetPassword': 'Réinitialiser le mot de passe',
  'auth.createAccount': 'Créer un compte',
  'auth.logIn': 'Se connecter',
  'auth.logInToPurchase': 'Se connecter pour acheter',

  // Auth - Account Create
  'auth.zipcodeOptional': 'Code postal (facultatif)',
  'auth.zipcodePlaceholder': 'Code postal',
  'auth.phoneNumberOptional': 'Numéro de téléphone (facultatif)',
  'auth.phoneNumber': 'Numéro de téléphone',
  'auth.birthdayOptional': 'Date de naissance (facultatif)',
  'auth.birthday': 'Date de naissance',
  'auth.subscribeToMarketing':
    'Je rejoins le fan-club et je m’inscris à la newsletter pour recevoir toutes les actus.',
  'auth.create': 'Créer',
  'auth.creating': 'Création en cours...',
  'auth.alreadyHaveAccount': 'Vous avez déjà un compte ?',

  // Auth - Reset Password
  'auth.submit': 'Envoyer',

  // Auth - Errors
  'auth.errorUnableToSignIn': 'Impossible de se connecter. Veuillez réessayer.',
  'auth.errorLoginGeneric': 'Une erreur est survenue lors de la connexion. Veuillez réessayer.',
  'auth.errorRequiredFields': 'Champs obligatoires manquants. Veuillez remplir le formulaire.',
  'auth.errorCreateGeneric': 'Veuillez utiliser "se connecter" si vous avez déjà un compte.',
  'auth.errorCreateAccount': 'Veuillez utiliser "se connecter" si vous avez déjà un compte.',
  'auth.errorEmailNotFound': 'Champ e-mail introuvable. Veuillez réessayer.',
  'auth.errorEnterEmail': 'Veuillez entrer votre adresse e-mail.',
  'auth.errorResetPassword': 'Un email vous avez été envoyé si vous avez un compte.',
  'auth.errorResetGeneric': 'Un email vous avez été envoyé si vous avez un compte.',
  'auth.error.login_required':
    'Connexion requise. Veuillez entrer votre e-mail et votre mot de passe.',
  'auth.error.invalid_credentials': 'E-mail ou mot de passe invalide. Veuillez réessayer.',
  'auth.error.account_already_exists':
    'Un compte avec cet e-mail existe déjà. Veuillez vous connecter.',
  'auth.error.invalid_email': "L'adresse e-mail saisie n'est pas valide. Veuillez réessayer.",
  'auth.error.weak_password':
    'Votre mot de passe est trop faible. Veuillez choisir un mot de passe plus sûr.',
  'auth.error.missing_fields':
    'Tous les champs sont obligatoires. Veuillez compléter le formulaire.',
  'auth.error.invalid_name':
    "Le nom saisi n'est pas valide. Veuillez utiliser uniquement des lettres.",
  'auth.error.password_mismatch': 'Les mots de passe ne correspondent pas. Veuillez réessayer.',
  'auth.error.missing_email': 'Veuillez entrer votre adresse e-mail.',
  'auth.error.email_not_found':
    "Nous n'avons trouvé aucun compte avec cette adresse e-mail. Veuillez vérifier et réessayer.",
  'auth.error.email_verify': 'Veuillez vérifier votre adresse e-mail et réessayer.',
  'auth.error.captcha_challenge':
    'Une vérification supplémentaire est requise. Veuillez compléter le contrôle de sécurité.',
  'auth.error.unknown_error': "Une erreur inconnue s'est produite. Veuillez réessayer plus tard.",

  // Product
  'product.buyNow': 'Acheter maintenant',
  'product.soldOut': 'Épuisé',
  'product.processing': 'Traitement en cours...',
  'product.errorAddToCart': "Impossible d'ajouter au panier.",

  // Need Access
  'access.logInToWatch': 'Se connecter pour regarder',
  'access.purchaseAccess': 'Obtenir un accès',
  'access.joinOrPurchase': "Rejoindre la communauté ou acheter l'accès",
  'access.noAccess': "Vous n'avez pas accès à ce contenu",
  'access.joinToUnlock': 'Rejoindre pour débloquer',
  'access.joinForAccess': 'Rejoindre pour accéder',
  'access.locked': 'Verrouillé',
  'access.joinToWatch': 'Rejoindre pour regarder',
  'access.joinOrPurchaseAccess': "Rejoindre ou acheter l'accès",
  'access.alreadyPurchased': 'Déjà client ?',
  'access.logInWithEmail': "Se connecter avec l'e-mail utilisé pour l'achat",
  'access.or': '- ou -',
  'access.noProductsAvailable': "Aucun produit donnant accès n'est actuellement disponible",
  'access.upgradeToAccess': 'Passer au niveau supérieur pour accéder',

  // Perks
  'perks.posts': 'Publications',
  'perks.videos': 'Vidéos',
  'perks.merch': 'Merch',
  'perks.codes': 'Codes',
  'perks.music': 'Musique',
  'perks.recentPosts': 'Publications récentes',
  'perks.myAccount': 'Mon compte',
  'perks.logout': 'Se déconnecter',
  'perks.noActiveMemberships': 'Aucun abonnement actif.',
  'perks.generating': 'Génération en cours...',
  'perks.noCodesFound': 'Aucun code trouvé',
  'perks.noProducts': 'Aucun produit',
  'perks.foundFor': 'trouvé pour "{query}"',
  'perks.more': 'Plus',
  'perks.join': 'Rejoindre',
  'perks.collectibles': 'Objets de collection',
  'perks.popularPosts': 'Publications populaires',
  'perks.noPosts': 'Aucun article',
  'perks.adjustFilters': "Essayez d'ajuster vos filtres ou revenez bientôt !",
  'perks.loadMorePosts': "Charger plus d'articles",
  'perks.loadMore': 'Charger plus',
  'perks.memberSince': 'Membre depuis',
  'perks.continueReading': 'Continuer la lecture',
  'perks.joinToContinueReading': 'Rejoindre pour continuer la lecture',
  'perks.beFirstToComment': 'Soyez le premier à laisser un commentaire !',
  'perks.addComment': 'Ajouter un commentaire...',
  'perks.addCommentButton': 'Ajouter un commentaire',
  'perks.joinToComment': 'Rejoindre pour commenter',
  'perks.commentRemoved': '[ supprimé ]',
  'perks.commentHasBeenRemoved': 'Le commentaire a été supprimé.',
  'perks.reply': 'Répondre',
  'perks.replyToComment': 'Répondre au commentaire...',
  'perks.viewReplies': 'Voir les réponses',
  'perks.loadMoreReplies': 'Charger plus de réponses',
  'perks.replyCount.one': '1 réponse',
  'perks.replyCount.other': '{count} réponses',
  'perks.filterPosts': 'Filtrer les articles',
  'perks.postType': "Type d'article",
  'perks.postTypeText': 'Texte',
  'perks.postTypeImages': 'Images',
  'perks.postTypeVideos': 'Vidéos',
  'perks.postTypeProducts': 'Produits',
  'perks.postTypeAudio': 'Audio',
  'a11y.play': 'Lecture',
  'a11y.pause': 'Pause',
  'a11y.seek': 'Progression',
  'a11y.audioArtwork': 'Pochette audio',
  'a11y.trackArtwork': 'Pochette de {title}',
  'a11y.viewArtwork': 'Voir la pochette',
  'perks.tags': 'Tags',
  'perks.authors': 'Auteurs',
  'perks.submission.submitPost': 'Soumettre une publication',
  'perks.submission.createPost': 'Créer une publication',
  'perks.submission.postingAs': 'Publier en tant que',
  'perks.submission.loginRequired': 'Connectez-vous à votre compte pour partager une publication.',
  'perks.submission.titleLabel': 'Titre',
  'perks.submission.titlePlaceholder': 'Donnez un titre à votre publication',
  'perks.submission.captionLabel': 'Légende',
  'perks.submission.captionPlaceholder': 'Ajoutez une légende',
  'perks.submission.addImage': 'Ajouter une photo',
  'perks.submission.changeImage': 'Changer la photo',
  'perks.submission.uploading': 'Téléchargement...',
  'perks.submission.submit': 'Soumettre pour révision',
  'perks.submission.submitting': 'Envoi en cours...',
  'perks.submission.post': 'Publier',
  'perks.submission.posting': 'Publication en cours...',
  'perks.submission.postAnother': 'Publier une autre',
  'perks.submission.success': 'Envoyé ! Votre publication est en attente de révision.',
  'perks.submission.successPublished': 'Votre publication est en ligne.',
  'perks.submission.submitAnother': 'Soumettre une autre',
  'perks.submission.invalidImageType': 'Veuillez choisir une image JPG, PNG ou GIF.',
  'perks.submission.invalidImageSize': 'Les images doivent faire moins de 25 Mo.',
  'perks.submission.errorUploadImage':
    "Une erreur s'est produite lors du téléchargement de votre image. Veuillez réessayer.",
  'perks.submission.errorSubmit':
    "Une erreur s'est produite lors de l'envoi de votre publication. Veuillez réessayer.",
  'perks.submission.errorLimit': 'Limite de soumissions atteinte. Réessayez demain.',
  'perks.submission.errorUsername':
    "Le nom d'utilisateur n'est pas disponible pour les soumissions",
  'perks.submission.removeImage': 'Supprimer la photo',
  'perks.badge.artist': 'Vérifié',
  'perks.badge.team': 'Équipe',
  'perks.shadowBanned': 'Bannissement fantôme : seuls ce fan et les modérateurs voient ceci. Levez-le dans votre tableau de bord Single, sous Posts > Paramètres.',
  'perks.artistProfileManaged': "Votre profil d'artiste est géré dans le tableau de bord Single",
  'perks.clearAll': 'Tout effacer',
  'perks.applyFilters': 'Appliquer les filtres',
  'perks.backToFeed': '← Retour au fil',
  'perks.backToLibrary': '← Retour à la bibliothèque',
  'music.album': 'Album',
  'music.download': 'Télécharger',
  'music.loginToDownload': 'Se connecter pour télécharger',
  'music.linkExpired': 'Ce lien a expiré.',
  'music.loginToAccess':
    "Veuillez vous connecter avec l'e-mail fourni lors de l'achat pour écouter ou télécharger.",
  'perks.noVideos': 'Aucune vidéo',
  'perks.noMusic': 'Aucune musique',
  'perks.gridView': 'Vue grille',
  'perks.listView': 'Vue liste',
  'perks.oops': 'Oups !',
  'perks.notFound': '404: Not Found',
  'perks.goBack': 'Retour',
  'perks.account': 'Compte',
  'perks.displayName': "Nom d'affichage",
  'perks.emailPreferences': 'Préférences e-mail',
  'perks.emailPreference.POST_NOTIFICATIONS': 'Nouvelles publications',
  'perks.emailPreference.POST_NOTIFICATIONS.description':
    "Recevez un e-mail lorsqu'une nouvelle publication est publiée.",
  'perks.emailPreference.COMMENT_NOTIFICATIONS': 'Commentaires et réponses',
  'perks.emailPreference.COMMENT_NOTIFICATIONS.description':
    "Recevez un e-mail lorsque quelqu'un répond à votre commentaire.",
  'perks.emailPreference.COMMENT_NOTIFICATIONS.description.submissions':
    "Recevez un e-mail lorsque quelqu'un répond à votre commentaire ou commente une publication que vous avez soumise.",
  'perks.emailPreference.COMMENT_NOTIFICATIONS.description.author':
    "Recevez un e-mail lorsque quelqu'un répond à votre commentaire ou commente une publication que vous avez publiée.",
  'perks.comments': 'Commentaires',
  'perks.view': 'Voir',
  'perks.transfer': 'Transférer',
  'perks.logInToViewCollectibles': 'Se connecter pour voir les objets de collection',
  'perks.viewAll': 'Voir tout',
  'perks.errorUploadAvatar': "Impossible de télécharger l'avatar. Veuillez réessayer.",
  'perks.profileCardTitle': 'Bienvenue ! Complétons votre profil de membre.',
  'perks.walletCardTitle': 'Téléchargez votre carte de membre',
  'perks.walletPassDescription':
    'Votre pass membre est une carte de club numérique pour votre appareil Apple ou Android. Il sera utilisé pour vous accorder des avantages spéciaux lors de spectacles et IRL.',
  'perks.walletScanDescription':
    'Scannez le code QR avec votre téléphone pour télécharger votre pass.',
  'perks.updatingProfile': 'Mise à jour...',
  'perks.updateProfile': 'Mettre à jour le profil',
  'perks.displayNamePlaceholder': 'Saisissez votre nom ici...',
  'perks.usernamePlaceholder': "Nom d'utilisateur",
  'perks.profileVisibilityNote':
    "Seuls votre avatar et votre nom d'affichage seront visibles par les autres membres.",
  'perks.trackCount': '{count} titres',
  'perks.trackCountOne': '{count} titre',
  'perks.commentCount': '{count} commentaires',
  'perks.commentCountOne': '{count} commentaire',
  'perks.replyingTo': 'En réponse à @{name}',
  'perks.postCommentButton': 'Publier',
  'perks.avatarAlt': 'Avatar de {name}',
  'perks.hiddenPostImageAlt': 'Image de publication masquée',
  'perks.postImageAlt': 'Image de la publication',
  'perks.imageSlideAlt': 'Diapositive',
  'perks.videoThumbnailAlt': 'Vignette de la vidéo',
  'perks.productImageAlt': 'Produit',
  'perks.membershipImageAlt': "image de l'adhésion",
  'perks.tierImageAlt': 'image du niveau',
  'perks.authorImageAlt': "image de l'auteur",
  'perks.submission.previewAlt': 'aperçu de la soumission',
  'a11y.countryCode': 'Indicatif du pays',
  'a11y.dismiss': 'Fermer',

  // Address Modal
  'address.updateAddress': "Mettre à jour l'adresse",
  'address.firstName': 'Prénom',
  'address.lastName': 'Nom',
  'address.street': 'Rue',
  'address.streetLine2': 'Rue (ligne 2)',
  'address.city': 'Ville',
  'address.country': 'Pays',
  'address.province': 'Province',
  'address.zip': 'Code postal',
  'address.phoneNumber': 'Numéro de téléphone',
  'address.update': 'Mettre à jour',
  'address.updating': 'Mise à jour en cours...',
  'address.errorStreetRequired': "L'adresse est obligatoire",
  'address.errorCountryRequired': 'Le pays est obligatoire',
  'address.errorZipRequired': 'Le code postal est obligatoire',
  'address.errorPhoneRequired': 'Le numéro de téléphone est obligatoire',

  // Common
  'common.cancel': 'Annuler',
  'common.ok': 'Ok',
  'common.close': 'Fermer',
  'common.dialog': 'Boîte de dialogue',
  'a11y.communityNav': 'Pages de la communauté',
  'a11y.likePost': 'Aimer la publication',
  'a11y.unlikePost': 'Ne plus aimer la publication',
  'a11y.viewComments': 'Voir les commentaires',
  'a11y.previousSlide': 'Diapositive précédente',
  'a11y.nextSlide': 'Diapositive suivante',
  'a11y.goToSlide': 'Aller à la diapositive {number}',
  'a11y.collapseComment': 'Réduire le commentaire',
  'a11y.expandComment': 'Développer le commentaire',
  'a11y.commentMenu': 'Options du commentaire',
  'a11y.deleteComment': 'Supprimer le commentaire',
  'a11y.likeComment': 'Aimer le commentaire',
  'a11y.unlikeComment': 'Ne plus aimer le commentaire',
  'a11y.reply': 'Répondre',
  'a11y.closeReplies': 'Fermer les réponses',
  'a11y.backToFeed': 'Retour au fil',
  'a11y.uploadAvatar': 'Télécharger un avatar',
  'common.searchByTitle': 'Rechercher par titre',
  'common.search': 'Rechercher',
  'common.clear': 'Effacer',
  'common.error': 'Erreur',
  'common.save': 'Enregistrer',
  'common.saving': 'Enregistrement...',
  'common.edit': 'Modifier',
  'common.delete': 'Supprimer',
  'common.loading': 'Chargement...',
  'common.uploading': 'Téléchargement...',
  'common.readMore': 'lire plus',
  'common.readLess': 'lire moins',
  'common.share': 'Partager',
  'common.copied': 'Copié !',
  'common.browserShareError':
    'Votre navigateur ne prend pas en charge les fonctionnalités de partage ou de presse-papiers.',
  'common.alreadyMember': 'Déjà membre ?',

  // Membership
  'membership.confirm': 'Confirmer',
  'membership.nevermind': 'Laisser tomber',
  'membership.noGoBack': 'Non, Retour',
  'membership.yesCancel': 'Oui, Annuler',
  'membership.goBack': 'Retour',
  'membership.continue': 'Continuer',
  'membership.confirmChange': 'Confirmer le changement',
  'membership.termsAndConditions': 'Conditions générales',
  'membership.updateBillingTerms': 'Mettre à jour vos conditions de facturation',
  'membership.confirmYourChanges': 'Confirmez vos modifications',
  'membership.confirmUpgrade': 'Confirmer la mise à niveau',
  'membership.confirmDowngrade': 'Confirmer le déclassement',
  'membership.termChange': 'Changement de terme',
  'membership.labelCancellation': 'Annulation {label}',
  'membership.cancelPendingTitle': 'Annuler {change}',
  'membership.yesCancelPending': 'Oui, annuler {change}',
  'membership.revertSettings': 'Votre {label} reviendra à ses paramètres précédents.',
  'membership.cancelTitle': 'Annuler {label}',
  'membership.areYouSureCancel': 'Êtes-vous sûr de vouloir annuler ?',
  'membership.cancellationEndOfTerm': 'Votre annulation prendra effet à la fin de votre période.',
  'membership.stillHaveAccess':
    'Cependant, vous aurez toujours accès à votre {label} payant pour le reste de votre période.',
  'membership.expirationDate': "Date d'expiration {label} :",
  'membership.notice': 'Avis :',
  'membership.cancellationNotice':
    "Les annulations {label} ne prennent effet qu'à la fin de votre période.",
  'membership.contactForQuestions':
    "Pour des questions sur l'annulation de votre {label}, veuillez contacter",
  'membership.contactIfUnsure':
    "Si vous n'êtes pas sûr que cela s'applique à votre commande spécifique, veuillez contacter le service client.",
  'membership.cancelMembershipButton': "Annuler l'abonnement",
  'membership.currentPlan': 'Plan actuel',
  'membership.newPlan': 'Nouveau plan',
  'membership.newPlanStarts': 'Votre nouveau plan commence le',
  'membership.newTierTerm': 'Nouveau terme de niveau :',
  'membership.nextBillingDateLabel': 'Prochaine date de facturation :',
  'membership.perMonth': '/Mois',
  'membership.aboutToUpgrade': "Vous êtes sur le point de mettre à niveau votre niveau d'adhésion.",
  'membership.aboutToDowngrade': "Vous êtes sur le point de rétrograder votre niveau d'adhésion.",
  'membership.viewMyPerks': 'Voir mes avantages',
  'membership.manage': 'Gérer',
  'membership.joining': 'Adhésion en cours...',
  'membership.join': 'Rejoindre',
  'membership.addingToCart': 'Ajout au panier...',
  'membership.upgrade': 'Mettre à niveau',
  'membership.downgrade': 'Rétrograder',
  'membership.cancelPendingChanges': 'Annuler les modifications en attente',
  'membership.active': 'Actif',
  'membership.nextBillingDate': 'Prochaine facturation',
  'membership.term': 'Période',
  'membership.changeTerm': '(modifier)',
  'membership.price': 'Prix',
  'membership.free': 'GRATUIT',
  'membership.per': 'par',
  'membership.oneTimePurchase': 'Achat unique',
  'membership.noMembershipsAvailable': 'Aucun abonnement disponible',
  'membership.transactionFailed': 'Transaction {label} échouée - Cliquez pour mettre à jour',
  'membership.noActiveMemberships': 'Aucun abonnement actif',
  'membership.pending': 'En attente',
  'membership.cancellation': 'Annulation',
  'membership.upgradeDowngrade': 'Mise à niveau / Déclassement',
  'membership.cancelLink': 'Annuler',
  'membership.nextShipment': 'Prochain envoi •',
  'membership.viewProduct': 'Voir le produit',
  'membership.hasBeenScheduled': 'a été planifié.',
  'membership.changingTo': 'Changement vers :',
  'membership.willBeDowngradedTo': 'Votre {label} sera rétrogradé à',
  'membership.on': 'le',
  'membership.stillHaveAccessUntil': "Vous aurez encore accès jusqu'au",
  'membership.cancelChange': 'Annuler le changement',
  'membership.nextBilling': 'Prochaine facturation',
  'membership.subscriptionShipMonthly': "Les commandes d'abonnement sont expédiées mensuellement.",
  'membership.noUpcomingBillDates': 'Aucune date de facturation prochaine.',
  'membership.orderHistory': 'Historique des commandes',
  'membership.emailWithTracking':
    'Vous recevrez un e-mail avec le suivi une fois votre commande expédiée.',
  'membership.back': '← Retour',
  'membership.shippingAddress': 'Adresse de livraison',
  'membership.missingAddress': "Informations d'adresse manquantes. Cliquez pour mettre à jour.",
  'membership.editShippingAddress': "Modifier l'adresse de livraison",
  'membership.paymentMethod': 'Méthode de paiement',
  'membership.updatePaymentInstructions':
    'Pour mettre à jour votre méthode de paiement, utilisez le lien ci-dessous. Un e-mail vous sera envoyé avec des instructions.',
  'membership.updatePaymentMethod': 'Mettre à jour la méthode de paiement',
  'membership.paymentFailed': 'Paiement échoué',
  'membership.productImageAlt': 'image du produit',
  'membership.detailMembership': 'Adhésion',
  'membership.detailBilling': 'Facturation',
  'membership.detailPlan': 'Formule',
  'membership.detailMemberId': 'ID de membre',
  'membership.detailSubscriptionNumber': 'N° d’abonnement',
  'membership.detailStatus': 'Statut',
  'membership.detailTerms': 'Conditions',
  'membership.detailLastPayment': 'Dernier paiement',
  'membership.receivedOn': 'Reçu le {date}',
  'membership.receivedAmountOn': '{amount} reçu le {date}',
  'membership.detailName': 'Nom',
  'membership.detailStreet': 'Rue',
  'membership.detailCity': 'Ville',
  'membership.detailState': 'État/Province',
  'membership.detailZip': 'Code postal',
  'membership.detailCountry': 'Pays',
  'membership.detailPhone': 'Téléphone',
  'membership.detailCard': 'Carte',
  'membership.detailNumber': 'Numéro',
  'membership.detailExpires': 'Expire',
  'membership.detailMethod': 'Méthode',
  'membership.manageLabel': 'Gérer {label}',

  // Music
  'music.exclusive': 'Exclusif',
  'music.trackTitle': 'Titre',
  'music.songCount': '{count} chansons',
  'music.songCountOne': '{count} chanson',
  'music.allTracksAvailableIn': 'TOUS LES TITRES DISPONIBLES DANS :',
  'music.preorderUnlock':
    'Précommandez maintenant et accédez au streaming ou au téléchargement le {date}.',
  'music.downloadUnavailable': 'Téléchargement indisponible',
  'music.downloadLimitReached':
    'Vous avez atteint la limite de téléchargements. Veuillez contacter la boutique.',
  'music.downloadFailed': 'Le téléchargement a échoué. Veuillez réessayer.',
  'music.downloadNotAllowed': "Connectez-vous avec l'e-mail utilisé lors de l'achat.",
  'music.downloadCodeUnavailable': "Ce téléchargement n'est pas disponible. Veuillez contacter la boutique.",
  'music.downloadStarted': 'Téléchargement lancé',
  'music.downloadStartedHint': "Consultez vos téléchargements ou l'app Fichiers.",
  'music.openInBrowserTitle': 'Téléchargement bloqué',
  'music.openInBrowserBody':
    'Le navigateur intégré que vous utilisez bloque les téléchargements. Vous devez ouvrir cette page dans un navigateur externe.',
  'music.openInBrowserHint':
    "Appuyez sur l'icône ••• et sélectionnez « Ouvrir dans un navigateur externe » pour continuer.",
  'music.demoArtist': 'Artiste test',
  'music.demoAlbum': 'Album démo',
  'music.demoTrack': 'Titre {n}',
  'a11y.previousTrack': 'Titre précédent',
  'a11y.nextTrack': 'Titre suivant',
  'a11y.playAll': 'Tout lire',

  // Video
  'video.startsIn': 'Commence dans :',
  'video.previewTitle': 'Titre de la vidéo',
  'video.previewArtist': "Nom de l'artiste",
  'video.previewDescription': 'Description de la vidéo',
};
